import React from 'react';
import './Desplegable.scss';

class Desplegable extends React.Component {
  render () {
    return (
      <div className="como__soy__container">
        <h1 className="como__soy__title">Como Soy</h1>
        <div className="accordion" id="accordionElement">
          <div className="card">
            <div className="card-header" id="headingOne">
              <h2 className="mb-0">
                <button className="btn btn-link" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                  Lorem ipsum
                </button>
              </h2>
            </div>
            <div id="collapseOne" className="collapse show" aria-labelledby="headingOne" data-parent="#accordionElement">
              <div className="card-body">
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed dui enim, tincidunt id dignissim vitae, condimentum nec nisl. Nulla facilisi. Nullam placerat, lectus non sodales facilisis, lacus massa sagittis sapien, nec cursus dui mi id risus. Suspendisse eu ante vel ligula fringilla imperdiet sed vehicula lacus.</p>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header" id="headingTwo">
              <h2 className="mb-0">
                <button className="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                  Lorem ipsum
                </button>
              </h2>
            </div>
            <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionElement">
              <div className="card-body">
                <ul>
                  <li><strong>Lorem ipsum: </strong>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed dui enim, tincidunt id dignissim vitae, condimentum nec nisl.</li>
                  <li><strong>Lorem ipsum: </strong>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed dui enim, tincidunt id dignissim vitae, condimentum nec nisl.</li>
                  <li><strong>Lorem ipsum: </strong>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed dui enim, tincidunt id dignissim vitae, condimentum nec nisl.</li>
                  <li><strong>Lorem ipsum: </strong>DLorem ipsum dolor sit amet, consectetur adipiscing elit. Sed dui enim, tincidunt id dignissim vitae, condimentum nec nisl.</li>
                  <li><strong>Lorem ipsum: </strong>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed dui enim, tincidunt id dignissim vitae, condimentum nec nisl.</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header" id="headingThree">
              <h2 className="mb-0">
                <button className="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                  Lorem ipsum
                </button>
              </h2>
            </div>
            <div id="collapseThree" className="collapse" aria-labelledby="headingThree" data-parent="#accordionElement">
              <div className="card-body">
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed dui enim, tincidunt id dignissim vitae, condimentum nec nisl. Nulla facilisi. Nullam placerat, lectus non sodales facilisis, lacus massa sagittis sapien, nec cursus dui mi id risus. Suspendisse eu ante vel ligula fringilla imperdiet sed vehicula lacus.</p>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header" id="headingFour">
              <h2 className="mb-0">
                <button className="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                  Lorem ipsum
                </button>
              </h2>
            </div>
            <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordionElement">
              <div className="card-body">
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed dui enim, tincidunt id dignissim vitae, condimentum nec nisl. Nulla facilisi. Nullam placerat, lectus non sodales facilisis, lacus massa sagittis sapien, nec cursus dui mi id risus. Suspendisse eu ante vel ligula fringilla imperdiet sed vehicula lacus.</p>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header" id="headingFive">
              <h2 className="mb-0">
                <button className="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                  Lorem ipsum
                </button>
              </h2>
            </div>
            <div id="collapseFive" class="collapse" aria-labelledby="headingFive" data-parent="#accordionElement">
              <div className="card-body">
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed dui enim, tincidunt id dignissim vitae, condimentum nec nisl. Nulla facilisi. Nullam placerat, lectus non sodales facilisis, lacus massa sagittis sapien, nec cursus dui mi id risus. Suspendisse eu ante vel ligula fringilla imperdiet sed vehicula lacus.</p>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header" id="headingSix">
              <h2 className="mb-0">
                <button class="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                  Lorem ipsum
                </button>
              </h2>
            </div>
            <div id="collapseSix" className="collapse" aria-labelledby="headingSix" data-parent="#accordionElement">
              <div className="card-body">
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed dui enim, tincidunt id dignissim vitae, condimentum nec nisl. Nulla facilisi. Nullam placerat, lectus non sodales facilisis, lacus massa sagittis sapien, nec cursus dui mi id risus. Suspendisse eu ante vel ligula fringilla imperdiet sed vehicula lacus.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Desplegable;
